/*
 * Action Types
 */
export enum LayoutTypes {
  SET_LAYOUT_VISIBLE = '@layout/SET_LAYOUT_VISIBLE',
}

/*
 * State type
 */
export interface LayoutState {
  readonly visible: boolean;
}
